module.exports = __webpack_public_path__ + "img/loading2.584b607f.gif";